module.exports = __webpack_public_path__ + "img/工作日志.793e6687.svg";